// components/common/ActionHistory.jsx
import './ActionHistory.css';

/**
 * @description
 * A reusable history table component for displaying activity or status history.
 * 
 * @example
 * <ActionHistory
 *    title="Project History"
 *    data={historyData}
 *    columns={[
 *      { key: 'user', label: 'User' },
 *      { key: 'created', label: 'Date Time' },
 *      { key: 'status', label: 'Status' }
 *    ]}
 * />
 */
const ActionHistory = ({
    title = 'Action History',
    data = [],
    columns = [],
    noDataMessage = 'No history found.',
}) => {
    return (
        <div className="action-history-container">
            {/* {title && <h3 className="action-history-title">{title}</h3>} */}
            <div className="action-history-table-wrapper">
                <table className="action-history-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            {columns.map((col) => (
                                <th key={col.key}>{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length > 0 ? (
                            data.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    {columns.map((col) => (
                                        <td key={col.key}>
                                            {item[col.key] ?? '-'}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={columns.length + 1}
                                    className="no-records"
                                >
                                    {noDataMessage}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ActionHistory;
